import Layout from "../../components/mainPage/Layout";
import powerSupplyImg from "../../images/powerSupply.png";
import manufactureImg from "../../images/manufacture.png"
import { Add } from "shared/components/Add";
import { ImageContainer } from "shared/components/ImageContainer";

export const Page = () => {
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <h1 className="acticle-title" >
            Диспетчерское управление электроснабжением промышленного предприятия
          </h1>
          <h2 className="section-title">
            SCADA NPT Expert+ для диспетчерского управления электроснабжением
            промышленного предприятия
          </h2>
          <p className="article-lead">
            Оптимальное управление энергопотреблением – ключевой фактор
            эффективности современного производства. SCADA NPT Expert+
            обеспечивает интеллектуальный контроль, автоматизацию и анализ
            системы электроснабжения промышленного предприятия, минимизируя
            простои и сокращая энергозатраты.
          </p>

          <h2 className="section-title">Ключевые модули и функции системы:</h2>

          <div className="quote-box-list">
            <div className="quote-box">
              <h3 className="feature-title">
                1. Базовая платформа и моделирование
              </h3>
              <ul className="feature-list">
                <li> <b>Ведение информационной модели электрической сети</b>
                  <ul>
                    <li>Единая цифровая модель сети предприятия (схемы 0,4 - 110 кВ) с атрибутами оборудования</li>
                    <li>Визуализация топологии сети в реальном времени и в ретроспективе</li>
                    <li>Учет взаимосвязей между элементами сети для автоматического анализа последствий переключений</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">
                2. Оперативное управление и электронные журналы
              </h3>
              <ul className="feature-list">
                <li><b>SCADA (Supervisory Control And Data Acquisition)</b>
                  <ul>
                    <li>Сбор и обработка телеметрической информации в реальном времени</li>
                    <li>Дистанционное управление коммутационными аппаратами (выключатели, разъединители)</li>
                    <li>Анализ оперативных и ретроспективных данных</li>
                    <li>Ведение базы тегов и архива данных с накоплением истории</li>
                  </ul>
                </li>
                <li><b>Ведение в электронном виде оперативной документации</b>
                  <ul>
                    <li>Цифровая оперативная документация: наряды-допуски и распоряжений, оперативные журналы, журналы учета бланков переключений и т.д.</li>
                    <li>Автоматическое внесение записей в процессе работы различных функций Системы</li>
                    <li>Привязка событий в системе к записям в журнале</li>
                  </ul>
                </li>
                <li><b>Управление переключениями</b>
                  <ul>
                    <li>Формирование автоматизированных программ/бланков переключений с проверкой условий выполнения переключений и последовательности операций на основе
                      информационной модели электрической сети и цели переключений </li>
                    <li>Пошаговое исполнение переключений с обязательной фиксацией состояния объектов переключений и возможностью приостановки/возобновления или остановки выполнения переключений</li>
                    <li>Автоматическое формирование записей в оперативном журнале при изменении статуса выполнения переключений по программе/бланку переключений</li>
                  </ul>
                </li>
                <li><b>Управление отключениями, происходящими в электросетевом комплексе</b>
                  <ul>
                    <li>Создание плановых отключений на основе плановой разрешенной и неотложной заявки</li>
                    <li>Автоматическое формирование последовательности переключений для изолирования поврежденного участка электрической сети и восстановления электроснабжения неповрежденных участков электроснабжения</li>
                    <li>Формирование бланков переключений на основе последовательностей переключений</li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="quote-box">
              <h3 className="feature-title">
                3. Анализ событий и организация работ
              </h3>
              <ul className="feature-list">
                <li><b>Определение участка повреждения</b>
                  <ul>
                    <li>Автоматическое определение зоны повреждения по сигналам и осциллограммам защит и контроллеров</li>
                    <li>Выделение участка сети на мнемосхеме для оперативного реагирования</li>
                    <li>Отображение координат и формирование ссылки для приложений карт (например, Yandex карты)</li>
                  </ul>
                </li>
                <li><b>Управление заявками</b>
                  <ul>
                    <li>Система учета заявок на выполнение работ</li>
                    <li>Контроль сроков исполнения и статусов заявок</li>
                  </ul>
                </li>
                <li><b>Управление допусками ремонтных бригад</b>
                  <ul>
                    <li>Электронный наряд-допуск с указанием рабочего места, бригады, ответственных</li>
                    <li>Блокировка оперативных переключений на время производства работ</li>
                    <li>Контроль соблюдения мер безопасности (проверка отсутствия напряжения, заземление)</li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="quote-box">
              <h3 className="feature-title">4. Инженерный анализ и расчеты</h3>
              <ul className="feature-list">
                <li><b>Расчетно-аналитические задачи</b>
                  <ul>
                    <li>Расчет установившихся режимов</li>
                    <li>Расчет токов короткого замыкания</li>
                    <li>
                      Определение места повреждения на ЛЭП (ОМП)
                    </li>
                  </ul>
                </li>

                <li>
                  <b>Оценивание состояния электрической сети</b>
                  <ul>
                    <li>Определение режима, наиболее соответствующего полученным значениям телеметрии (текущих или архивных)</li>
                    <li>Выявление недостоверных значений обрабатываемых измерений</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">
                5. Подготовка персонала
              </h3>
              <ul className="feature-list">
                <li><b>Тренажер оперативно-диспетчерского персонала</b>
                  <ul>
                    <li>Режимный тренажер с использованием информационной модели, графических схем подстанций и однолинейных схем сети, используемых в процессе оперативно-технологического управления </li>
                    <li>
                      Тренажер переключений с учетом типовых сценариев переключений, используемых при оперативно-технологическом управлении
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="quote-box">
              <h3 className="feature-title">
                6. Интеграция и отчетность
              </h3>
              <ul className="feature-list">
                <li><b>Обмен информацией со смежными системами</b>
                  <ul>
                    <li>Интеграция с АСУ ТП технологических цехов (OPC UA, Modbus, МЭК 61850)</li>
                    <li>
                      Обмен данными с корпоративными системами (ERP, EAM, 1C) по REST API, MQTT и др. протоколам
                    </li>
                    <li>
                      Предоставление данных в АСДУ РДУ/СО
                    </li>
                  </ul>
                </li>
                <li><b>Формирование отчетов</b>
                  <ul>
                    <li>Конструктор отчетов для формирования пользовательских документов</li>
                    <li>
                      Стандартные отчеты по надежности (SAIFI, SAIDI), потреблению, потерям, КЭ и т.д.
                    </li>
                    <li>
                      Автоматическая рассылка отчетов по расписанию
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <h2 className="section-title">Преимущества внедрения:</h2>
          <ul className="benefits-list">
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Снижение потерь электроэнергии </strong> – до 7-10% за
              счет оптимизации режимов работы энергетического комплекса
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Сокращение простоев </strong> – предупреждение, быстрое обнаружение и
              устранение технологических нарушений
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Повышение надежности </strong> – минимизация рисков
              отключений критического оборудования
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Повышение оперативности </strong> – автоматическое формирование бланка переключений, защита от ошибочных действий оперативного персонала при переключениях
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Прозрачность энергопотребления </strong> – точный учет и
              прогнозирование затрат
            </li>
          </ul>
          {/* <div className="cta-block">
            <p className="cta-text">
              <strong>
                Автоматизируйте управление предприятием – повысьте эффективность
                производства и снизьте затраты!
              </strong>
            </p>
          </div> */}
          <div className="image-container">
            <ImageContainer
              src={powerSupplyImg}
              alt={'SCADA NPT Expert на промышленном предприятии'}
              caption={'SCADA NPT Expert на промышленном предприятии'}
            />
          </div>
          <Add
            text={<div style={{ fontSize: '2rem' }}><span style={{ color: 'var(--accent-color)' }}>Автоматизируйте</span> управление предприятием! </div>}
            description={<div style={{ fontSize: '1.3rem' }}>Повысьте эффективность производства и снизьте затраты!</div>}
            image={manufactureImg}
          />
        </div>
      </div>
    </Layout>
  );
};

export const meta = {
  title: 'Диспетчерское управление электроснабжением промышленного предприятия',
  description: 'SCADA NPT Expert+ для диспетчерского управления электроснабжением промышленного предприятия'
}